import { hbs } from 'ember-cli-htmlbars';
export default hbs("<li>\n  <Ui::LinkPlain\n    @route={{@route}}\n    @query={{@query}}\n    class=\'navigation-bar__item\'\n    ...attributes\n  >\n    {{@label}}\n  </Ui::LinkPlain>\n</li>")